module.exports = __webpack_public_path__ + "static/media/H_detectGraphImage_active.c4c6fc93.png";